var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button-separate',{class:_vm.classP,attrs:{"icon":"mdi-plus","disabled":_vm.disabled,"loading":_vm.loading,"primary":_vm.primary,"small":_vm.small,"x-small":_vm.xSmall}},[(_vm.isSlot)?[_vm._t("default")]:[_vm._v(" Pridėti ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }